import * as React from 'react';
import type { DropViewState, DragData } from 'owa-dnd';
import { useProjectId } from 'owa-timestream-asset-sdk';
import handleSubtaskDrop from '../utils/handleSubtaskDrop';
import type { SubTaskDragData } from '../schema';

export const SUBTODO_DRAG_TYPE = 'TimeStreamSubTodo';

export function useOnDrop(targetTaskId: string, targetSubtaskId?: string) {
    const projectId = useProjectId();
    return React.useCallback(
        (dragData: DragData) => {
            switch (dragData.itemType) {
                case SUBTODO_DRAG_TYPE:
                    const { parentTaskId, subtaskId } = dragData.itemData as SubTaskDragData;
                    if (parentTaskId === targetTaskId) {
                        handleSubtaskDrop(projectId, parentTaskId, subtaskId, targetSubtaskId);
                    }
                    break;
            }
        },
        [targetTaskId, targetSubtaskId, projectId]
    );
}

export function canDropSubtask(dragInfo: DragData) {
    return dragInfo.itemType === SUBTODO_DRAG_TYPE;
}

export function useOnDragOver(setDropState: (dropViewState: DropViewState) => void) {
    return React.useCallback(
        (dragInfo: DragData) =>
            setDropState({
                isDragOver: true,
                draggableItemType: dragInfo.itemType,
            }),
        [setDropState]
    );
}

export function useOnDragLeave(setDropState: (dropViewState: DropViewState) => void) {
    return React.useCallback(
        (_: DragData) =>
            setDropState({
                isDragOver: false,
                draggableItemType: '',
            }),
        [setDropState]
    );
}
